export default 'salesmanApp';
